import { render, staticRenderFns } from "./setaccountpwd.vue?vue&type=template&id=681924ca"
import script from "./setaccountpwd.vue?vue&type=script&lang=js"
export * from "./setaccountpwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports